import { type FC, useEffect, useMemo } from "react";
import PaymentModal from "../PaymentModal";
import { type PaymentModalProps } from "../PaymentModal";
import { connect, type ConnectedProps } from "react-redux";
import type { AppDispatch, RootState } from "../../../../Application/globaltypes/redux";
import { bindAction } from "../../../../../interfaces";
import { fetchAccountPackLicense } from "../../../../Accounts/EditAccount/state/thunks/editAccountPackLicenseThunk";
import {
  accountPackLicenseSelector,
  reset,
} from "../../../../Accounts/EditAccount/state/slices/editAccountPackLicenseSlice";
import { useFeatureFlag } from "../../../../../hooks/useFeatureFlag";
import { FeatureFlags } from "../../../../../featureFlags";

export const SinglePaymentModalContainer: FC<PaymentModalProps & PropsFromRedux> = (props) => {
  const { accountId, paymentPacks, fetchAccountPackLicense, accountPackLicense, resetAccountPackLicense } = props;
  const additionalPurchaseEnabled = useFeatureFlag(FeatureFlags.AdditionalPurchase);
  const { isPurchased, isExpired, isTrial, packId } = paymentPacks[0];

  const isAdditionalPurchase = useMemo(() => {
    return additionalPurchaseEnabled && isPurchased && !isExpired && !isTrial;
  }, [additionalPurchaseEnabled, isExpired, isPurchased, isTrial]);

  useEffect(() => {
    if (isPurchased) {
      fetchAccountPackLicense(packId, accountId);
    }
    return () => resetAccountPackLicense();
  }, [accountId, fetchAccountPackLicense, isPurchased, packId, resetAccountPackLicense]);

  const currentPaymentPacks = useMemo(() => {
    return paymentPacks.map((pack) => {
      return {
        ...pack,
        expirationDate: isAdditionalPurchase ? accountPackLicense?.expirationDate : undefined,
        purchasingLicenses: isAdditionalPurchase ? 0 : accountPackLicense?.assingedLicensesCount || 0,
        licensesCount: isAdditionalPurchase ? 0 : accountPackLicense?.assingedLicensesCount || 0,
      };
    });
  }, [accountPackLicense, isAdditionalPurchase, paymentPacks]);

  return (
    <PaymentModal
      onPaymentSuccess={props.onPaymentSuccess}
      onClose={props.onClose}
      paymentPacks={currentPaymentPacks}
    />
  );
};

/* istanbul ignore next */
const mapStateToProps = (state: RootState) => ({
  accountId: state.userProfile.accountId,
  accountPackLicense: accountPackLicenseSelector(state).accountPackLicense,
});
/* istanbul ignore next */
const mapDispatchToProps = (dispatch: AppDispatch) => ({
  fetchAccountPackLicense: bindAction(fetchAccountPackLicense, dispatch),
  resetAccountPackLicense: bindAction(reset, dispatch),
});

const connector = connect(mapStateToProps, mapDispatchToProps);
const ConnectedComponent = connector(SinglePaymentModalContainer);
export type PropsFromRedux = ConnectedProps<typeof connector>;
export default ConnectedComponent;
